<svg #PuzzleSvg id="testPuzzle" class="testPuzzle" viewBox="0 0 1280 720" xmlns="http://www.w3.org/2000/svg">
  <text id="correct" y="360" font-size="100px">✅</text>
  <text id="incorrect" y="360" font-size="100px">❌</text>
</svg>